import React from "react";
import { Box, Typography, Button } from "@mui/material";
import MUITypography from "../../Components/MUITypography";
import { ROUTE_REGISTRATION } from "../../Util/VMConstants";
import { useNavigate } from "react-router-dom";
import { toTitleCase } from "../../Util/UtilHelper";

const VenueManagerSection = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, sm: 4, md: 8 },
        backgroundColor: "background.default",
      }}
    >
      <Box maxWidth="1200px" mx="auto">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={{ xs: 4, md: 6 }}
          textAlign="center"
        >
          {/* Heading */}
          <MUITypography
            variant="h2"
            fontWeight={700}
            sx={{
              fontSize: { xs: 26, sm: 30, md: 36 },
              lineHeight: 1.3,
              maxWidth: 900,
            }}
          >
            Venue Manager CRM - Build For Your Event Venue Industry
          </MUITypography>

          {/* Content */}
          <Box
            display="flex"
            flexDirection={{ xs: "column-reverse", lg: "row" }}
            alignItems="center"
            justifyContent="space-between"
            gap={{ xs: 4, md: 6 }}
            width="100%"
          >
            {/* Text */}
            <Box
              flex={1}
              textAlign={{ xs: "center", lg: "left" }}
              maxWidth={620}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.125rem" },
                  lineHeight: 1.8,
                  color: "text.secondary",
                }}
              >
                {toTitleCase("Venue Manager CRM offers a comprehensive application designed \n "+
                "specifically for venue managers handling event bookings and \n "+
                "operations. The platform allows you to add and manage team \n "+
                "members — including managers, executives, and security staff — \n "+
                "based on their departments and roles, ensuring smooth \n "+
                "coordination across your venue. With its user-friendly interface "+
                "and advanced features, Venue Manager empowers sales teams to "+
                "streamline operations, improve efficiency, and deliver "+
                "exceptional customer service.")}
              </Typography>
            </Box>

            {/* Image */}
            <Box
              flex={1}
              display="flex"
              justifyContent="center"
            >
              <Box
                component="img"
                src={'/static/vm_box_logo.jpg'}
                alt="Venue Manager CRM"
                sx={{
                  width: { xs: 220, sm: 260, md: 300 },
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>

          {/* CTA */}
          <Button
            variant="contained"
            size="large"
            onClick={() =>
              navigate(`/${ROUTE_REGISTRATION}`, { replace: true })
            }
            sx={{
              mt: 3,
              px: { xs: 4, md: 6 },
              py: 1.6,
              fontSize: "1rem",
              fontWeight: 600,
              borderRadius: 2,
              textTransform: "none",
              boxShadow: "0px 10px 24px rgba(0,0,0,0.12)",
            }}
          >
            Get Started Now
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default VenueManagerSection;
